function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.944 9.116a.623.623 0 00-.569-.366h-2.5V.625A.625.625 0 0011.25 0h-2.5a.625.625 0 00-.625.625V8.75h-2.5a.626.626 0 00-.47 1.036l4.375 5a.623.623 0 00.94 0l4.375-5a.623.623 0 00.099-.67z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 13.75v3.75H3.125v-3.75h-2.5v5c0 .691.56 1.25 1.25 1.25h16.25c.691 0 1.25-.559 1.25-1.25v-5h-2.5z",
  fill: "#fff"
});

function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconDownload;